import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  Grid,
  TableCell,
  TableBody,
  TableRow,
  CircularProgress,
  TableHead,
  Table,
  TableContainer,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Collapse,
  DialogActions,
  useTheme,
  useMediaQuery,
  TextField,
  Hidden,
  Dialog,
  Select,
  DialogContent,
  FormControlLabel,
  ListItem,
  InputLabel,
  FormControl,
  Typography,
  InputAdornment,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Divider,
  Chip,
  Backdrop,
  Card,
  CardContent,
  CardActions,
  Tooltip,
} from '@material-ui/core';
import CallMadeIcon from '@material-ui/icons/CallMade';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PrintIcon from '@material-ui/icons/Print';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PaymentIcon from '@material-ui/icons/Payment';
import EditIcon from '@material-ui/icons/Edit';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DateRangeIcon from '@material-ui/icons/DateRange';
import DescriptionIcon from '@material-ui/icons/Description'; // Icone para Promissória

import { Field, Form, Formik } from 'formik';
import { Autocomplete } from '@material-ui/lab';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {
  startOfWeek,
  startOfToday,
  startOfMonth,
  isEqual,
  addDays,
  addMonths,
  format,
} from 'date-fns';

import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import UIContainer from '../../UI/Container/UIContainer';

import StoreContext from '../../Store/context';
import UICardSale from '../../UI/Card/Sale/UICardSale';

import {
  emptyObject,
  formattedCurrency,
  goToReferenceId,
  isEqualObject,
  formatClient, // Helper para formatar nome do cliente
} from '../../../utils/utils';
import UIFilter from '../../UI/Button/Filter/UIFilter';
import useApi from '../../../utils/useApi';
import UIButtonSearch from '../../UI/Button/Search/Search';
import UIModalFilter from '../../UI/ModalFilter/UIModalFilter';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import GreenSwitch from '../../UI/Form/Switch/GreenSwitch';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import MyDateRangePicker from '../../UI/Form/DateRangePicker/DateRangePicker';

// Importação do Módulo de Promissória
import { preparePromissoryData, printPromissoryNote } from '../../PromissoryNote/PromissoryNote';
import ReactDOMServer from 'react-dom/server';
import PrintPreviewModal from '../Print/PrintPreviewModal';
import { printThermal } from '../../../utils/printThermal';

import './saleSearch.css';
import useStyles from '../../../utils/useStyle';
import UITablePagination from '../../UI/Table/Pagination/UITablePagination';
import '../cupom.css';

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const initialSearch = {
  id: '',
  customer: null,
  products: null,
  services: null,
  promotion: null,
  value: '',
  amountPaid: '',
  plots: null,
  interest: null,
  userId: null,
  isClosed: '0',
  observation: '',
};

const initialPayment = {
  amountPaid: 0,
  plots: 1,
  paymentMethod: 6,
};

const initialTextConfirm = {
  confirmationPrompt: '',
  requiredPrompt: 'fechar venda',
  allow: false,
};

const SaleSearch = (children) => {
  const { referenceId } = children;
  const { credencials, setModalCashierSelect } = useContext(StoreContext);
  const { disabledTextField } = useStyles();
  const [alert, setAlert] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [confirmationPrompt, setConfirmationPrompt] =
    useState(initialTextConfirm);

  const setTextConfirm = (value) => {
    value.allow =
      value?.confirmationPrompt?.toLowerCase() ===
      initialTextConfirm.requiredPrompt;
    setConfirmationPrompt(value);
  };

  // constantes para collapse na view de detalhes
  const [collapseItem, setCollapseItem] = useState(false);
  const [collapsePlots, setCollapsePlots] = useState(false);

  // verificar se é mobile e constantes para versão mobile
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  // constantes para modal de pagamentos
  const [modalPay, setModalPay] = useState(false);
  const [payment, setPayment] = useState(initialPayment);
  const [modalTerminates, setModalTerminates] = useState(false);

  // modais de pesquisa e filtragem
  const [view, setView] = useState(false);
  const [modalValues, setModalValues] = useState(null);
  const [filter, setFilter] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [mySales, setMySales] = useState(true);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [alertTerminates, setAlertTerminates] = useState(false);

  // state para pagamentos em lote
  const [selectedSales, setSelectedSales] = useState([]);
  const [modalBatchPay, setModalBatchPay] = useState(false);
  const [batchPayment, setBatchPayment] = useState({ paymentMethod: 6 });
  const [alertBatch, setAlertBatch] = useState(false);

  // state para recibos em lote
  const [batchReceipts, setBatchReceipts] = useState(null);
  const [showBatchReceipt, setShowBatchReceipt] = useState(false);
  const [singleReceiptData, setSingleReceiptData] = useState(null);
  const [showSingleReceipt, setShowSingleReceipt] = useState(false);

  // State para controle do modal de impressão com opções (Térmico / A4)
  const [modalPrint, setModalPrint] = useState(false);
  const [printSaleData, setPrintSaleData] = useState(null);

  const handleOpenPrintSale = async (dataToPrint) => {
    let target = dataToPrint || modalValues;
    if (!target) return;
    setLoadingDetails(true);
    try {
      let treated = target;
      if (!treated.products || !Array.isArray(treated.products) || typeof treated.userId === 'number') {
        treated = await formatModalValues(target);
      }
      if (treated) {
        const customerId = treated.customer?.id || treated.customer;
        const fullClient = clientInfo.data
          ? clientInfo.data.find((c) => c.id === customerId)
          : null;
        const customerFormatted = formatClient(treated.customer, clientInfo);
        const readyData = {
          ...treated,
          customerData:
            fullClient ||
            (typeof treated.customer === 'object'
              ? treated.customer
              : { name: customerFormatted }),
          customerFormatted,
        };
        setPrintSaleData(readyData);
        setModalPrint(true);
      }
    } finally {
      setLoadingDetails(false);
    }
  };

  // --- Função para Gerar Promissória ---
  const handlePrintPromissory = () => {
    if (!modalValues || !modalValues.customer) return;

    // Tenta obter o objeto completo do cliente a partir da lista carregada (para ter CPF, Endereço, etc)
    const customerId = modalValues.customer.id || modalValues.customer;
    const fullClient = clientInfo.data ? clientInfo.data.find(c => c.id === customerId) : null;

    // Se não achar na lista (ex: lista paginada), usa o objeto parcial que estiver na venda
    const clientData = fullClient || (typeof modalValues.customer === 'object' ? modalValues.customer : { name: 'Cliente', id: customerId });

    // 1. Tratamento seguro da Data da Venda (Evita Invalid Date)
    let saleDate = new Date(); // Valor padrão (hoje) se falhar

    if (modalValues.moment) {
      // Se for string e tiver barras, assume formato BR (dd/MM/yyyy)
      if (typeof modalValues.moment === 'string' && modalValues.moment.includes('/')) {
        try {
          const [datePart, timePart] = modalValues.moment.split(' ');
          const [day, month, year] = datePart.split('/');

          // Nota: Mês no construtor Date começa em 0 (Jan = 0)
          const parsedDate = new Date(year, parseInt(month, 10) - 1, day);

          // Adiciona hora se existir para manter precisão
          if (timePart) {
            const [hours, minutes, seconds] = timePart.split(':');
            if (hours) parsedDate.setHours(hours);
            if (minutes) parsedDate.setMinutes(minutes);
            if (seconds) parsedDate.setSeconds(seconds);
          }

          if (!isNaN(parsedDate.getTime())) {
            saleDate = parsedDate;
          }
        } catch (e) {
          console.error("Erro ao parsear data da venda:", e);
          // Mantém saleDate como hoje
        }
      } else {
        // Tenta construtor padrão (ISO ou objeto Date já existente)
        const tryDate = new Date(modalValues.moment);
        if (!isNaN(tryDate.getTime())) {
          saleDate = tryDate;
        }
      }
    }

    // Prepara as parcelas se houver
    let installmentsList = null;
    if (modalValues.plots && Object.keys(modalValues.plots).length > 0) {
      installmentsList = Object.entries(modalValues.plots).map(([key, value]) => {
        // Limpa string "100.00 - PAGA" para float
        const amount = typeof value === 'string' ? parseFloat(value.split(' - ')[0]) : value;
        const dueDate = addMonths(saleDate, Number(key));

        return {
          number: key,
          value: amount,
          dueDate: dueDate
        };
      });
    }

    const noteData = preparePromissoryData({
      client: clientData,
      companyData: credencials.companyData,
      totalValue: modalValues.value,
      emissionDate: saleDate,
      installments: installmentsList
    });

    printPromissoryNote(noteData);
  };

  function printSingleReceipt(receipt) {
    if (!receipt) return;
    const html = ReactDOMServer.renderToStaticMarkup(
      <ThermalReceiptTemplate data={receipt} />
    );
    printThermal(html);
  }

  function printBatchReceipts() {
    if (!batchReceipts || batchReceipts.length === 0) return;
    const html = batchReceipts
      .map(
        (receipt) =>
          `<div style="page-break-after: always;">${ReactDOMServer.renderToStaticMarkup(
            <ThermalReceiptTemplate data={receipt} />,
          )}</div>`,
      )
      .join('');
    printThermal(html);
  }

  function handleModalTerminates(values, isClick) {
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setModalValues(values);
    setModalTerminates(!modalTerminates);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // salvar valores do form de pesquisa
  const [search, setSearch] = useState(emptyObject(initialSearch));

  // manipular datas do range date
  const [dateValues, setDateValues] = useState({
    startDate: new Date(),
    endDate: null,
    key: 'selection',
  });

  const [filterLoad, filterInfo, setFilterInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/sales',
    onCompleted: (res) => {
      if (!res) {
        setFilterInfo();
      }
    },
  });

  const [updateLoad, updateInfo] = useApi({
    method: 'put',
    url: '/sales',
  });

  const [terminatesLoad, terminatesInfo, setTerminatesInfo] = useApi({
    method: 'delete',
    url: '/sales',
  });

  const [productsLoad, productsInfo] = useApi({
    method: 'get',
    url: '/products',
  });

  const [servicesLoad, servicesInfo] = useApi({
    method: 'get',
    url: '/services',
  });

  const [promotionsLoad, promotionsInfo] = useApi({
    method: 'get',
    url: '/promotions',
    params: { isActive: 1 },
  });

  const [userLoad, userInfo] = useApi({
    method: 'get',
    url: '/users',
  });

  const [clientLoad, clientInfo] = useApi({
    method: 'get',
    url: '/customers',
  });

  const [paymentLoad, paymentInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/payments/methods',
  });

  const [payLoad, payInfo, setPayInfo] = useApi({
    debounceDelay: 500,
    method: 'patch',
    url: '/sales',
  });

  const [searchLoad] = useApi({
    method: 'get',
  });

  const contentRef = useRef();

  async function formatModalValues(data) {
    try {
      setLoadingDetails(true);
      setModalValues(null);
      const response = await searchLoad({
        url: '/sales',
        params: { id: data.id },
      });
      if (response && response.data && response.data.length > 0) {
        const [values] = response.data;
        const itemList = [];

        // 1. Tentar carregar pelo snapshot detalhado (itemsDetails)
        let details = values.itemsDetails;
        if (typeof details === 'string') {
          try {
            details = JSON.parse(details);
          } catch (e) {
            details = null;
          }
        }

        if (details && (details.products?.length > 0 || details.services?.length > 0)) {
          (details.products || []).forEach((p) => {
            const price = Number(p.price) || 0;
            const amount = Number(p.amount) || 1;
            const subtotal = p.subtotal !== undefined ? Number(p.subtotal) : price * amount;
            const discount = Number(p.discount) || 0;
            const total = p.total !== undefined ? Number(p.total) : subtotal - discount;

            itemList.push({
              id: p.id,
              name: p.item || p.name || `Produto #${p.id}`,
              amount,
              price,
              subtotal,
              discount,
              total,
              isEligible: p.isEligible,
              type: 'product',
            });
          });

          (details.services || []).forEach((s) => {
            const price = Number(s.price) || 0;
            const amount = Number(s.amount) || 1;
            const subtotal = s.subtotal !== undefined ? Number(s.subtotal) : price * amount;
            const discount = Number(s.discount) || 0;
            const total = s.total !== undefined ? Number(s.total) : subtotal - discount;

            itemList.push({
              id: s.id,
              name: s.item || s.name || `Serviço #${s.id}`,
              amount,
              price,
              subtotal,
              discount,
              total,
              isEligible: s.isEligible,
              type: 'service',
            });
          });
        } else {
          // Fallback para vendas antigas sem snapshot gravado
          const productPromises = Object.entries(values.products || {}).map(
            async ([id, amount]) => {
              const res = await searchLoad({
                url: '/products',
                params: { id },
              });
              if (res && res.data && res.data[0]) {
                const prod = res.data[0];
                const price = Number(prod.value) || 0;
                const numAmount = Number(amount) || 1;
                itemList.push({
                  id,
                  name: prod.name,
                  amount: numAmount,
                  price,
                  subtotal: price * numAmount,
                  discount: 0,
                  total: price * numAmount,
                  type: 'product',
                });
              } else {
                itemList.push({ id, name: `Produto #${id}`, amount });
              }
            },
          );

          const servicePromises = Object.entries(values.services || {}).map(
            async ([id, amount]) => {
              const res = await searchLoad({
                url: '/services',
                params: { id },
              });
              if (res && res.data && res.data[0]) {
                const serv = res.data[0];
                const price = Number(serv.value) || 0;
                const numAmount = Number(amount) || 1;
                itemList.push({
                  id,
                  name: serv.name,
                  amount: numAmount,
                  price,
                  subtotal: price * numAmount,
                  discount: 0,
                  total: price * numAmount,
                  type: 'service',
                });
              } else {
                itemList.push({ id, name: `Serviço #${id}`, amount });
              }
            },
          );

          await Promise.all([...productPromises, ...servicePromises]);
        }

        // Ensure user and promotion lists are loaded before searching
        const [usersResponse, promotionsResponse] = await Promise.all([
          userLoad(),
          promotionsLoad(),
        ]);

        const { interest } = values;
        const userId = (usersResponse?.data || []).find(
          (value) => value.id === values.userId,
        );
        const promotion = (promotionsResponse?.data || []).find(
          (value) => value.id === values.promotion,
        );
        const { plots } = values;
        const valuesTreated = {
          ...values,
          userId: userId
            ? `${userId.name} ${userId.lastName || ''}`
            : 'Desconhecido',
          interest: typeof interest === 'object' ? (interest?.percentage ?? 0) : (interest ?? 0),
          promotion: promotion && promotion.name,
          products: itemList,
          plots,
        };
        setModalValues(valuesTreated);
        return valuesTreated;
      }
      return null;
    } finally {
      setLoadingDetails(false);
    }
  }

  const onEditSale = (data) => {
    const updateValues = {
      id: data.id,
      customer: data.customer && data.customer.id,
      observation: data.observation,
    };

    updateLoad({
      debounced: true,
      data: emptyObject(updateValues),
    });
    setView(!view);
    setAlert(true);
  };

  function onCloseSale() {
    if (confirmationPrompt.allow) {
      const params = { id: modalValues.id };
      terminatesLoad({
        params,
        onCompleted: (res) => {
          if (res) {
            filterLoad({
              params: search,
            });
            setAlertTerminates(true);
          }
        },
      });
    } else {
      setTextConfirm({
        ...confirmationPrompt,
        error: 'Digite o texto corretamente para poder finalizar',
      });
    }
  }

  // ação para click direito
  const [clickRight, setClickRight] = useState(initialClick);
  const handleClickRight = (event, values) => {
    event.preventDefault();
    if (values) {
      formatModalValues(values);
    }
    setClickRight({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleCloseClickRight = () => {
    setClickRight(initialClick);
  };

  // ação para click esquerdo
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickLeft = (event, values) => {
    if (values) {
      formatModalValues(values);
    }
    setAnchorEl(event.currentTarget);
  };

  const handleCloseClickLeft = () => {
    setAnchorEl(null);
  };

  function handleModalFilter() {
    setFilter(!filter);
  }

  useEffect(() => {
    if (referenceId) {
      initialSearch.id = referenceId;
    }
    const params = referenceId
      ? { id: referenceId }
      : { userId: credencials.id, isClosed: '0' };

    filterLoad({
      params,
    });
    userLoad();
    productsLoad();
    promotionsLoad();
    servicesLoad();
    clientLoad();
    paymentLoad();

    // Check for openPayment and openDetails params
    const urlParams = new URLSearchParams(window.location.search);
    if (referenceId) {
      if (urlParams.get('openPayment') === 'true') {
        formatModalValues({ id: referenceId }).then(() => {
          setModalPay(true);
        });
      }
      if (urlParams.get('openDetails') === 'true') {
        formatModalValues({ id: referenceId }).then(() => {
          setTimeout(() => {
            setView(true);
          }, 500);
        });
      }
    }
  }, []);

  async function handleModalPay(values, isClick) {
    if (values) {
      await formatModalValues(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setModalPay(!modalPay);
  }

  async function handleModalView(values, isClick) {
    if (values) {
      await formatModalValues(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    const timer = setTimeout(
      () => {
        setView(!view);
        setCollapseItem(false);
        setCollapsePlots(false);
      },
      !view ? 250 : 1,
    );
    return () => clearTimeout(timer);
  }

  function onSearch(values) {
    const products = values.products
      ? values.products.map((value) => Number(value.id))
      : null;
    const services = values.services
      ? values.services.map((value) => Number(value.id))
      : null;

    const params = {
      ...values,
      customer: values.customer && values.customer.id,
      promotion: values.promotion && values.promotion.id,
      userId:
        (values.userId && values.userId.id) || (mySales && credencials.id),
      services: services && JSON.stringify(services),
      products: products && JSON.stringify(products),
      isClosed: isClosed ? '1' : '0',
      interest: values.interest === 0 ? '0' : values.interest,
      startRange:
        (dateValues.endDate && dateValues.startDate) || values.startRange,
      endRange: isEqual(dateValues.endDate, dateValues.startDate)
        ? addDays(dateValues.endDate, 1)
        : dateValues.endDate,
    };
    filterLoad({
      debounced: true,
      params: emptyObject(params),
      onCompleted: () => {
        setSearch(emptyObject(params));
        setSelectedSales([]);
      },
    });
    setPage(0);
  }

  function onChangeClosed(closed) {
    setIsClosed(closed);
    const searchValues = {
      ...search,
      isClosed: closed ? 1 : '0',
      userId: mySales && credencials.id,
    };
    filterLoad({
      params: emptyObject(searchValues),
      onCompleted: (res) => {
        if (res) {
          setSearch(emptyObject(searchValues));
          setSelectedSales([]);
        }
      },
    });
    setPage(0);
  }

  function onChangeMySale(closed) {
    setMySales(closed);
    const searchValues = {
      ...search,
      userId: closed && credencials.id,
      isClosed: isClosed ? 1 : '0',
    };
    filterLoad({
      params: emptyObject(searchValues),
      onCompleted: (res) => {
        if (res) {
          setSearch(emptyObject(searchValues));
          setSelectedSales([]);
        }
      },
    });
    setPage(0);
  }

  function changeValuesPayment(value, attribute) {
    if (Number(value) > 0) {
      setPayment({ ...payment, [attribute]: value, errors: false });
    } else {
      setPayment({ ...payment, errors: 'Pagamento invalido' });
    }
  }

  // Função para preencher o valor da próxima parcela não paga
  function handlePayNextInstallment() {
    if (!modalValues || !modalValues.plots) return;

    const plots = modalValues.plots;
    // Garante a ordem das parcelas (1, 2, 3...)
    const sortedKeys = Object.keys(plots).sort((a, b) => Number(a) - Number(b));

    for (const key of sortedKeys) {
      const valueStr = plots[key];
      // Verifica se a parcela já foi paga
      const isPaid = typeof valueStr === 'string' && valueStr.toUpperCase().includes('PAGA');

      if (!isPaid) {
        // Encontrou a próxima parcela pendente
        // Remove qualquer texto extra se houver e converte para float
        const amount = parseFloat(String(valueStr).split(' - ')[0]);
        changeValuesPayment(amount, 'amountPaid');
        return;
      }
    }
  }

  function onPay() {
    if (!credencials.cashSession) {
      setModalCashierSelect(true);
    } else if (Number(payment.amountPaid) > 0) {
      const paymentMethodName =
        (paymentInfo.data || []).find((p) => p.id === payment.paymentMethod)?.name ||
        'Desconhecido';
      const data = {
        id: modalValues.id,
        plots: payment.plots,
        cashRegister: credencials.cashSession,
        amountPaid: payment.amountPaid,
        paymentMethod: payment.paymentMethod,
      };
      payLoad({
        data,
        onCompleted: () => {
          // Prepara dados do recibo
          const receipt = {
            ...modalValues,
            paidNow: payment.amountPaid,
            paymentMethodName: paymentMethodName,
            value: modalValues.value,
          };

          setAlert(false); // Garante que o alert antigo não apareça
          setModalPay(false); // Fecha o modal de pagamento

          // Define dados e abre o modal de recibo
          setSingleReceiptData(receipt);
          setShowSingleReceipt(true);

          filterLoad({
            params: search,
          });
        },
      });
    }
  }

  function onBatchPay() {
    if (!credencials.cashSession) {
      setModalCashierSelect(true);
      return;
    }
    const salesToPay = filterInfo.data.filter((sale) =>
      selectedSales.includes(sale.id),
    );
    let success = false;
    const receiptsGenerated = [];

    salesToPay.forEach((sale, index) => {
      const amountToPay = parseFloat(sale.value) - parseFloat(sale.amountPaid);
      if (amountToPay > 0) {
        success = true;
        // Preparar dados para o recibo
        receiptsGenerated.push({
          ...sale,
          paidNow: amountToPay,
          paymentMethodName:
            paymentInfo.data &&
            paymentInfo.data.find((p) => p.id === batchPayment.paymentMethod)
              ?.name || 'Desconhecido',
        });

        payLoad({
          data: {
            id: sale.id,
            plots: 1,
            cashRegister: credencials.cashSession,
            amountPaid: amountToPay,
            paymentMethod: batchPayment.paymentMethod,
          },
          onCompleted: () => {
            if (index === salesToPay.length - 1) {
              setBatchReceipts(receiptsGenerated);
              setModalBatchPay(false);
              setShowBatchReceipt(true);
              filterLoad({ params: search });
              setSelectedSales([]);
            }
          },
        });
      }
    });

    if (!success) {
      setModalBatchPay(false);
      setSelectedSales([]);
    }
  }

  const totalPendingBatch = filterInfo.data
    ? filterInfo.data
      .filter((sale) => selectedSales.includes(sale.id))
      .reduce(
        (acc, sale) =>
          acc + (parseFloat(sale.value) - parseFloat(sale.amountPaid)),
        0,
      )
    : 0;

  // Componente de Template de Recibo Térmico (para pagamento rápido via iframe)
  const ThermalReceiptTemplate = ({ data }) => (
    <div style={{ width: '100%', maxWidth: '76mm', fontFamily: 'Courier New, Courier, monospace', fontSize: '12px', color: 'black', background: 'white', padding: '2mm', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '5px' }}>
        <h2 style={{ fontWeight: 'bold', textTransform: 'uppercase', margin: '5px 0' }}>Recibo - Não Fiscal</h2>
        <p style={{ margin: '2px 0' }}>{format(new Date(), 'dd/MM/yyyy HH:mm')}</p>
      </div>

      <div style={{ borderTop: '1px dashed black', margin: '5px 0', width: '100%' }} />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Venda:</span>
        <span>#{data.id}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Cliente:</span>
        <span>{formatClient(data.customer, clientInfo)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Vendedor:</span>
        <span>{credencials.name || '---'}</span>
      </div>

      <div style={{ borderTop: '1px dashed black', margin: '5px 0', width: '100%' }} />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Total:</span>
        <span>{formattedCurrency(data.value)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Pago Agora:</span>
        <span style={{ fontWeight: 'bold' }}>{formattedCurrency(data.paidNow)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
        <span>Método:</span>
        <span>{data.paymentMethodName}</span>
      </div>

      <div style={{ borderTop: '1px dashed black', margin: '5px 0', width: '100%' }} />

      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <p style={{ margin: '2px 0' }}>Obrigado pela preferência!</p>
        <p style={{ margin: '2px 0' }}>Volte sempre.</p>
      </div>
    </div>
  );

  return (
    <>
      <div id="screen-content">
        <UIContainer container>
          <Grid
            item
            container
            justify="space-between"
            alignItems="center"
            xs={12}
          >
            <UIFormTitle title="Filtrar vendas" />
            <UIFilter onClick={handleModalFilter} />
          </Grid>
          <Formik onSubmit={onSearch} initialValues={initialSearch}>
            {({ submitForm, values, setFieldValue }) => (
              <Form style={{ width: '100%' }} onChange={() => submitForm()}>
                <Grid container direction="row" alignItems="center" spacing={1}>
                  <Hidden smDown>
                    <Grid item xs={1}>
                      <Field
                        name="id"
                        label="ID"
                        placeholder="ID"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                  </Hidden>
                  <Grid item xs={5} md={2}>
                    <Autocomplete
                      clearOnEscape
                      noOptionsText="Sem opções"
                      disabled={clientInfo.loading || clientInfo.error}
                      options={clientInfo.data !== null ? clientInfo.data : []}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(client) => client.name}
                      renderOption={(option) => (
                        <>
                          {option.name} {option.lastName || ''}
                        </>
                      )}
                      onChange={(ev, value) => {
                        setFieldValue('customer', value);
                        submitForm();
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Cliente"
                          variant="standard"
                          placeholder="Informe um cliente"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={7} md={4}>
                    <Autocomplete
                      multiple
                      noOptionsText="Sem opções"
                      disabled={productsInfo.loading}
                      options={productsInfo.data || []}
                      getOptionLabel={(option) => option.name}
                      onChange={(ev, value) => {
                        setFieldValue('products', value);
                        submitForm();
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Produtos"
                          placeholder="Informe os produtos"
                        />
                      )}
                    />
                  </Grid>
                  <Hidden smDown>
                    <Grid item xs={4}>
                      <MyDateRangePicker
                        label="Data"
                        submitForm={submitForm}
                        state={dateValues}
                        setState={setDateValues}
                      />
                    </Grid>
                    <UIButtonSearch xs={1} />
                  </Hidden>
                  <Grid container justify="center" alignItems="center">
                    <UICardSale
                      onClick={() => onSearch({ startRange: startOfToday() })}
                      name="Vendas de hoje"
                    />
                    <UICardSale
                      onClick={() =>
                        onSearch({ startRange: startOfWeek(new Date()) })
                      }
                      name="Vendas da semana"
                    />
                    <UICardSale
                      onClick={() =>
                        onSearch({ startRange: startOfMonth(new Date()) })
                      }
                      name="Vendas do mês"
                    />
                    <Hidden mdUp>
                      <Grid item>
                        <FormControlLabel
                          label={mySales ? 'Minhas vendas' : 'De todos'}
                          labelPlacement="start"
                          control={
                            <GreenSwitch
                              checked={mySales}
                              onChange={(ev) => {
                                onChangeMySale(ev.target.checked);
                              }}
                            />
                          }
                        />
                        <FormControlLabel
                          label={isClosed ? 'Vendas fechadas' : 'Vendas abertas'}
                          labelPlacement="start"
                          control={
                            <GreenSwitch
                              checked={!isClosed}
                              onChange={(ev) => {
                                onChangeClosed(!ev.target.checked);
                              }}
                            />
                          }
                        />
                      </Grid>
                    </Hidden>
                  </Grid>
                </Grid>

                <UIModalFilter
                  open={filter}
                  changeModal={handleModalFilter}
                  submit={submitForm}
                >
                  <Hidden mdUp>
                    <Grid item xs={2} md={1}>
                      <Field
                        name="id"
                        label="ID"
                        placeholder="ID"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                  </Hidden>

                  <Grid item xs={10} md={12}>
                    <Autocomplete
                      clearOnEscape
                      noOptionsText="Sem opções"
                      disabled={userInfo.loading}
                      options={userInfo.data || []}
                      onChange={(ev, value) => {
                        setFieldValue('userId', value);
                        submitForm();
                        if (values.userId) setMySales(false);
                      }}
                      getOptionLabel={(user) => user.name}
                      renderOption={(option) => (
                        <>
                          {option.name} {option.lastName}
                        </>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Vendedor"
                          variant="standard"
                          placeholder="Informe um vendedor"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      clearOnEscape
                      noOptionsText="Sem opções"
                      disabled={promotionsInfo.loading}
                      options={promotionsInfo.data || []}
                      onChange={(ev, value) => {
                        setFieldValue('promotion', value);
                        submitForm();
                      }}
                      getOptionLabel={(promotion) => promotion.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Promoção"
                          variant="standard"
                          placeholder="Informe a promoção"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      noOptionsText="Sem opções"
                      disabled={servicesInfo.loading}
                      options={servicesInfo.data || []}
                      getOptionLabel={(option) => option.name}
                      onChange={(event, service) =>
                        setFieldValue('services', service)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Serviços"
                          placeholder="Informe os serviços"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CurrencyTextField
                      type="tel"
                      value={values.value}
                      label="Valor da venda"
                      variant="standard"
                      decimalCharacter=","
                      digitGroupSeparator="."
                      currencySymbol="R$"
                      outputFormat="string"
                      onChange={(ev, value) => setFieldValue('value', value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CurrencyTextField
                      type="tel"
                      value={values.amountPaid}
                      label="Valor pago"
                      variant="standard"
                      decimalCharacter=","
                      digitGroupSeparator="."
                      currencySymbol="R$"
                      outputFormat="string"
                      onChange={(ev, value) => setFieldValue('amountPaid', value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Field
                      name="plots"
                      label="Parcelas"
                      type="number"
                      as={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Field
                      name="interest"
                      label="Juros"
                      type="number"
                      as={TextField}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <Field
                      name="observation"
                      label="Observação"
                      placeholder="Informe uma observação"
                      fullWidth
                      as={TextField}
                    />
                  </Grid>
                  <Hidden mdUp>
                    <Grid item xs={6}>
                      <Autocomplete
                        clearOnEscape
                        noOptionsText="Sem opções"
                        disabled={promotionsInfo.loading}
                        options={promotionsInfo.data || []}
                        onChange={(ev, value) => {
                          setFieldValue('promotion', value);
                          submitForm();
                        }}
                        getOptionLabel={(promotion) => promotion.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Promoção"
                            variant="standard"
                            placeholder="Informe a promoção"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <MyDateRangePicker
                        label="Data"
                        submitForm={submitForm}
                        state={dateValues}
                        setState={setDateValues}
                      />
                    </Grid>
                  </Hidden>
                </UIModalFilter>
              </Form>
            )}
          </Formik>
        </UIContainer>

        <UIContainer>
          <Grid
            item
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            xs={12}
          >
            <UIFormTitle
              title={`${(
                filterInfo?.data?.reduce(
                  (a, b) =>
                    a +
                    (b.isClosed == 1
                      ? 0
                      : parseFloat(b.value) - parseFloat(b.amountPaid)),
                  0,
                ) || 0
              ).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })} pendente`}
            />
            {selectedSales.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<MonetizationOnIcon />}
                onClick={() => setModalBatchPay(true)}
              >
                Receber {selectedSales.length} Selecionada(s)
              </Button>
            )}
            <Hidden smDown>
              <Grid item>
                <FormControlLabel
                  label={mySales ? 'Minhas vendas' : 'De todos'}
                  labelPlacement="start"
                  control={
                    <GreenSwitch
                      checked={mySales}
                      onChange={(ev) => {
                        onChangeMySale(ev.target.checked);
                      }}
                    />
                  }
                />
                <FormControlLabel
                  label={isClosed ? 'Vendas fechadas' : 'Vendas abertas'}
                  labelPlacement="start"
                  control={
                    <GreenSwitch
                      checked={!isClosed}
                      onChange={(ev) => {
                        onChangeClosed(!ev.target.checked);
                      }}
                    />
                  }
                />
              </Grid>
            </Hidden>
          </Grid>
          <Grid item xs>
            {/* Tabela Desktop */}
            <Hidden smDown>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={
                            selectedSales.length > 0 &&
                            selectedSales.length < (filterInfo.data?.length || 0)
                          }
                          checked={
                            (filterInfo.data?.length || 0) > 0 &&
                            selectedSales.length === (filterInfo.data?.length || 0)
                          }
                          onChange={(event) => {
                            if (event.target.checked) {
                              const newSelecteds = filterInfo.data
                                .filter(
                                  (sale) =>
                                    parseFloat(sale.value) -
                                      parseFloat(sale.amountPaid) >
                                    0,
                                )
                                .map((n) => n.id);
                              setSelectedSales(newSelecteds);
                              return;
                            }
                            setSelectedSales([]);
                          }}
                        />
                      </TableCell>
                      <TableCell>ID</TableCell>
                      <TableCell>Cliente</TableCell>
                      <TableCell>Valor</TableCell>
                      <TableCell>Faltando</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Horário da compra</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filterInfo.loading && <CircularProgress />}
                    {filterInfo.data &&
                      filterInfo.data
                        .slice(
                          page * rowsPerPage,
                          rowsPerPage === -1
                            ? undefined
                            : page * rowsPerPage + rowsPerPage,
                        )
                        .map((data) => {
                          const isItemSelected =
                            selectedSales.indexOf(data.id) !== -1;
                          const isPaid =
                            parseFloat(data.value) - parseFloat(data.amountPaid) <=
                            0;
                          return (
                            <TableRow
                              onDoubleClick={() => handleModalView(data)}
                              onContextMenu={
                                !mobile
                                  ? (ev) => handleClickRight(ev, data)
                                  : undefined
                              }
                              style={{ cursor: 'context-menu' }}
                              onClick={
                                mobile
                                  ? (ev) => handleClickLeft(ev, data)
                                  : undefined
                              }
                              hover
                              key={data.id}
                              selected={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  disabled={isPaid}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    const selectedIndex = selectedSales.indexOf(
                                      data.id,
                                    );
                                    let newSelected = [...selectedSales];
                                    if (selectedIndex === -1) {
                                      newSelected.push(data.id);
                                    } else {
                                      newSelected.splice(selectedIndex, 1);
                                    }
                                    setSelectedSales(newSelected);
                                  }}
                                />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.id}
                              </TableCell>
                              <TableCell>
                                {formatClient(data.customer, clientInfo)}
                              </TableCell>
                              <TableCell>{formattedCurrency(data.value)}</TableCell>
                              <TableCell>
                                {formattedCurrency(
                                  parseFloat(data.value) -
                                    parseFloat(data.amountPaid),
                                )}
                              </TableCell>
                              <TableCell>
                                {Number(data.isClosed) === 1
                                  ? 'Fechada'
                                  : 'Em aberto'}
                              </TableCell>
                              <TableCell>{data.moment}</TableCell>
                              <TableCell>
                                <Tooltip title="Receber venda">
                                  <span>
                                    <IconButton
                                      onClick={() => handleModalPay(data)}
                                      disabled={isPaid}
                                      size="small"
                                    >
                                      <MonetizationOnIcon />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                <Tooltip title="Visualizar">
                                  <IconButton
                                    onClick={() => handleModalView(data)}
                                    size="small"
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Imprimir">
                                  <IconButton
                                    onClick={() => handleOpenPrintSale(data)}
                                    size="small"
                                  >
                                    <PrintIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Fechar venda">
                                  <span>
                                    <IconButton
                                      disabled={data.isClosed == '1'}
                                      onClick={() => handleModalTerminates(data)}
                                      size="small"
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    <Menu
                      keepMounted
                      open={clickRight.mouseY !== null}
                      onClose={handleCloseClickRight}
                      anchorReference="anchorPosition"
                      anchorPosition={
                        clickRight.mouseY !== null && clickRight.mouseX !== null
                          ? {
                              top: clickRight.mouseY,
                              left: clickRight.mouseX,
                            }
                          : undefined
                      }
                    >
                      <MenuItem onClick={() => handleModalView(null, true)}>
                        Visualizar
                      </MenuItem>
                      <MenuItem onClick={() => handleOpenPrintSale(modalValues)}>
                        Imprimir
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleModalPay(null, true)}
                        disabled={
                          modalValues?.isClosed == 1 ||
                          parseFloat(modalValues?.value) -
                            parseFloat(modalValues?.amountPaid) <=
                            0
                        }
                      >
                        Receber Venda
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleModalTerminates(null, true)}
                        disabled={modalValues?.isClosed == 1}
                      >
                        Fechar Venda
                      </MenuItem>
                    </Menu>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={() => handleCloseClickLeft()}
                    >
                      <MenuItem onClick={() => handleModalView(null, true)}>
                        Visualizar
                      </MenuItem>
                      <MenuItem onClick={() => handleOpenPrintSale(modalValues)}>
                        Imprimir
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleModalPay(null, true)}
                        disabled={
                          modalValues?.isClosed == 1 ||
                          parseFloat(modalValues?.value) -
                            parseFloat(modalValues?.amountPaid) <=
                            0
                        }
                      >
                        Receber venda
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleModalTerminates(null, true)}
                        disabled={modalValues?.isClosed == 1}
                      >
                        Fechar Venda
                      </MenuItem>
                    </Menu>
                    {filterInfo.error && (
                      <TableRow>
                        <TableCell colSpan={8}>Sem resultados encontrados</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <UITablePagination
                  count={filterInfo.data ? filterInfo.data.length : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Hidden>

            {/* Listagem em Cards Mobile */}
            <Hidden mdUp>
              <Box style={{ width: '100%' }}>
                {filterInfo.loading && (
                  <CircularProgress style={{ margin: '16px auto', display: 'block' }} />
                )}
                {filterInfo.data &&
                  filterInfo.data
                    .slice(
                      page * rowsPerPage,
                      rowsPerPage === -1
                        ? undefined
                        : page * rowsPerPage + rowsPerPage,
                    )
                    .map((data) => {
                      const isItemSelected = selectedSales.indexOf(data.id) !== -1;
                      const isPaid =
                        parseFloat(data.value) - parseFloat(data.amountPaid) <= 0;
                      const isClosedSale = Number(data.isClosed) === 1;

                      let borderColor = '#17497F';
                      let statusText = 'Em aberto';
                      let chipColor = 'primary';

                      if (isPaid) {
                        borderColor = '#9E9E9E';
                        statusText = 'Paga';
                        chipColor = 'default';
                      } else if (isClosedSale) {
                        borderColor = '#9E9E9E';
                        statusText = 'Fechada';
                        chipColor = 'default';
                      }

                      return (
                        <Card
                          key={data.id}
                          variant="outlined"
                          style={{
                            marginBottom: 12,
                            borderLeft: `4px solid ${borderColor}`,
                            backgroundColor: isItemSelected ? '#F0F4F8' : '#FFFFFF',
                            borderRadius: 8,
                          }}
                        >
                          <CardContent style={{ paddingBottom: 8 }}>
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              mb={1}
                            >
                              <Box display="flex" alignItems="center">
                                <Checkbox
                                  checked={isItemSelected}
                                  disabled={isPaid}
                                  size="small"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    const selectedIndex = selectedSales.indexOf(
                                      data.id,
                                    );
                                    let newSelected = [...selectedSales];
                                    if (selectedIndex === -1) {
                                      newSelected.push(data.id);
                                    } else {
                                      newSelected.splice(selectedIndex, 1);
                                    }
                                    setSelectedSales(newSelected);
                                  }}
                                  style={{ padding: '0 8px 0 0' }}
                                />
                                <Typography
                                  variant="subtitle1"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  #{data.id} - {formatClient(data.customer, clientInfo)}
                                </Typography>
                              </Box>
                              <Chip
                                label={statusText}
                                size="small"
                                color={chipColor}
                                variant="outlined"
                              />
                            </Box>
                            <Divider style={{ margin: '8px 0' }} />
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                  display="block"
                                >
                                  Valor Total
                                </Typography>
                                <Typography
                                  variant="body2"
                                  style={{ fontWeight: 600 }}
                                >
                                  {formattedCurrency(data.value)}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                  display="block"
                                >
                                  Faltando
                                </Typography>
                                <Typography
                                  variant="body2"
                                  style={{
                                    fontWeight: 600,
                                    color: isPaid ? '#388E3C' : '#D32F2F',
                                  }}
                                >
                                  {formattedCurrency(
                                    parseFloat(data.value) -
                                      parseFloat(data.amountPaid),
                                  )}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                  display="block"
                                >
                                  Horário da Compra
                                </Typography>
                                <Typography variant="body2">
                                  {data.moment}
                                </Typography>
                              </Grid>
                            </Grid>
                          </CardContent>
                          <Divider />
                          <CardActions
                            style={{ justifyContent: 'flex-end', padding: '4px 8px' }}
                          >
                            <Tooltip title="Receber venda">
                              <span>
                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={() => handleModalPay(data)}
                                  disabled={isPaid}
                                >
                                  <MonetizationOnIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title="Visualizar">
                              <IconButton
                                size="small"
                                onClick={() => handleModalView(data)}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Imprimir">
                              <IconButton
                                size="small"
                                onClick={() => handleOpenPrintSale(data)}
                              >
                                <PrintIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Fechar venda">
                              <span>
                                <IconButton
                                  size="small"
                                  color="secondary"
                                  disabled={data.isClosed == '1'}
                                  onClick={() => handleModalTerminates(data)}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </CardActions>
                        </Card>
                      );
                    })}
                {filterInfo.error && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                    style={{ padding: 16 }}
                  >
                    Sem resultados encontrados
                  </Typography>
                )}
                <UITablePagination
                  count={filterInfo.data ? filterInfo.data.length : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </Box>
            </Hidden>
          </Grid>
        </UIContainer>

        {/* Sticky Bottom Action Bar (Mobile) */}
        {mobile && selectedSales.length > 0 && (
          <Paper
            elevation={10}
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1300,
              backgroundColor: '#17497F',
              color: '#FFFFFF',
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
              {selectedSales.length} venda(s) selecionada(s)
            </Typography>
            <Box display="flex" gridGap={8}>
              <Button
                size="small"
                variant="outlined"
                style={{ color: '#FFF', borderColor: '#FFF' }}
                onClick={() => setSelectedSales([])}
              >
                Limpar
              </Button>
              <Button
                size="small"
                variant="contained"
                style={{ backgroundColor: '#4CAF50', color: '#FFF' }}
                startIcon={<MonetizationOnIcon />}
                onClick={() => setModalBatchPay(true)}
              >
                Receber
              </Button>
            </Box>
          </Paper>
        )}

        {modalValues && (
          <>
            <Dialog open={view} onClose={() => handleModalView()} maxWidth="md" fullWidth>
              <Formik enableReinitialize onSubmit={onEditSale} initialValues={modalValues}>
                {({ values, submitForm, setFieldValue }) => (
                  <Form>
                    <UIDialogTitle
                      id="form-dialog-title"
                      onClose={() => handleModalView()}
                    >
                      Detalhes da Venda
                    </UIDialogTitle>
                    <DialogContent ref={contentRef}>
                      <Grid container spacing={3}>
                        {/* Section 1: Status & Key Info (Read Only) */}
                        <Grid item xs={12}>
                          <Box display="flex" gap={2} flexWrap="wrap" alignItems="center" justifyContent="space-between" mb={2}>
                            <Typography variant="h6" color="primary">
                              Venda #{modalValues.id}
                            </Typography>
                            <Box display="flex" gap={2}>
                              <Chip icon={<DateRangeIcon />} label={values.moment} size="small" />
                              <Chip label={`Vendedor: ${values.userId}`} size="small" />
                              {values.promotion && (
                                <Chip label={`Promoção: ${values.promotion}`} size="small" color="secondary" variant="outlined" />
                              )}
                            </Box>
                          </Box>
                          <Divider />
                        </Grid>

                        {/* Section 2: Editable Fields (Highlighted) */}
                        <Grid item xs={12} md={6}>
                          <Box p={2} bgcolor="#f9f9f9" borderRadius={8} border="1px solid #e0e0e0">
                            <Typography variant="subtitle2" gutterBottom style={{ display: 'flex', alignItems: 'center', color: '#3f51b5' }}>
                              <EditIcon fontSize="small" style={{ marginRight: 8 }} /> Dados Editáveis
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <Autocomplete
                                  clearOnEscape
                                  noOptionsText="Sem opções"
                                  disabled={clientInfo.loading || clientInfo.error}
                                  options={clientInfo.data !== null ? clientInfo.data : []}
                                  getOptionSelected={(option, value) => option.id === value.id}
                                  getOptionLabel={(client) => client.name}
                                  renderOption={(option) => (
                                    <>
                                      {option.name} {option.lastName || ''}
                                    </>
                                  )}
                                  onChange={(ev, value) => setFieldValue('customer', value)}
                                  defaultValue={clientInfo.data && clientInfo.data.find((item) => item.id === values.customer)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Cliente"
                                      variant="outlined"
                                      size="small"
                                      helperText="Você pode alterar o cliente desta venda"
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <Field
                                  name="observation"
                                  label="Observações"
                                  placeholder="Adicionar notas internas..."
                                  as={TextField}
                                  variant="outlined"
                                  multiline
                                  rows={3}
                                  fullWidth
                                  size="small"
                                  onChange={(ev) => setFieldValue('observation', ev.target.value)}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>

                        {/* Section 3: Financial Summary (Read Only) */}
                        <Grid item xs={12} md={6}>
                          <Box p={2} height="100%">
                            <Typography variant="subtitle2" gutterBottom style={{ display: 'flex', alignItems: 'center', color: '#4caf50' }}>
                              <AttachMoneyIcon fontSize="small" style={{ marginRight: 8 }} /> Resumo Financeiro
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <CurrencyTextField
                                  label="Valor Total"
                                  value={values.value}
                                  disabled
                                  variant="standard"
                                  fullWidth
                                  currencySymbol="R$"
                                  decimalCharacter=","
                                  digitGroupSeparator="."
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <CurrencyTextField
                                  label="Valor Pago"
                                  value={values.amountPaid}
                                  disabled
                                  variant="standard"
                                  fullWidth
                                  currencySymbol="R$"
                                  decimalCharacter=","
                                  digitGroupSeparator="."
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Link to={() => goToReferenceId(2, values.id)}>
                                          <IconButton size="small" title="Ver histórico">
                                            <CallMadeIcon fontSize="small" />
                                          </IconButton>
                                        </Link>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <CurrencyTextField
                                  label="Desconto"
                                  value={values.discount}
                                  disabled
                                  variant="standard"
                                  fullWidth
                                  currencySymbol="R$"
                                  decimalCharacter=","
                                  digitGroupSeparator="."
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <CurrencyTextField
                                  label="Acréscimo"
                                  value={values.increase}
                                  disabled
                                  variant="standard"
                                  fullWidth
                                  currencySymbol="R$"
                                  decimalCharacter=","
                                  digitGroupSeparator="."
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <Field
                                  name="interest"
                                  label="Juros (%)"
                                  as={TextField}
                                  disabled
                                  fullWidth
                                  variant="standard"
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>

                        {/* Section 4: Items List (Detailed Table with fallback) */}
                        <Grid item xs={12}>
                          <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', color: '#17497F' }}>
                            <ShoppingCartIcon fontSize="small" style={{ marginRight: 8 }} />
                            Itens da Venda ({modalValues.products?.length || 0})
                          </Typography>
                          <TableContainer component={Paper} variant="outlined" style={{ maxHeight: 320 }}>
                            <Table size="small" stickyHeader>
                              <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                                <TableRow>
                                  <TableCell><strong>Produto/Serviço</strong></TableCell>
                                  <TableCell align="center"><strong>Qtd</strong></TableCell>
                                  <TableCell align="right"><strong>Unitário</strong></TableCell>
                                  <TableCell align="right"><strong>Desconto</strong></TableCell>
                                  <TableCell align="right"><strong>Total</strong></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {modalValues?.products?.map((item, index) => {
                                  const hasDisc = Number(item.discount) > 0;
                                  return (
                                    <TableRow hover key={index}>
                                      <TableCell>
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
                                          <span>{item.name}</span>
                                          {hasDisc && (
                                            <span
                                              style={{
                                                fontSize: '0.72rem',
                                                backgroundColor: '#E8F5E9',
                                                color: '#2E7D32',
                                                padding: '2px 6px',
                                                borderRadius: 4,
                                                fontWeight: 600,
                                              }}
                                            >
                                              -{formattedCurrency(item.discount)}
                                            </span>
                                          )}
                                        </div>
                                      </TableCell>
                                      <TableCell align="center">{item.amount}</TableCell>
                                      <TableCell align="right">
                                        {item.price !== undefined ? formattedCurrency(item.price) : '-'}
                                      </TableCell>
                                      <TableCell align="right" style={{ color: hasDisc ? '#16A34A' : '#666' }}>
                                        {hasDisc ? `-${formattedCurrency(item.discount)}` : '-'}
                                      </TableCell>
                                      <TableCell align="right" style={{ fontWeight: 600 }}>
                                        {item.total !== undefined ? formattedCurrency(item.total) : (item.price ? formattedCurrency(item.price * item.amount) : '-')}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                                {(!modalValues?.products || modalValues.products.length === 0) && (
                                  <TableRow>
                                    <TableCell colSpan={5} align="center">Nenhum item encontrado</TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>

                        {/* Section 5: Installments (Improved Table) */}
                        <Grid item xs={12}>
                          <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', color: '#17497F' }}>
                            <PaymentIcon fontSize="small" style={{ marginRight: 8 }} />
                            Parcelamento ({values.plots ? Object.keys(values.plots).length : 0}x)
                          </Typography>
                          <TableContainer component={Paper} variant="outlined" style={{ maxHeight: 220 }}>
                            <Table size="small" stickyHeader>
                              <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                                <TableRow>
                                  <TableCell><strong>Parcela</strong></TableCell>
                                  <TableCell align="right"><strong>Valor</strong></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {values.plots &&
                                  Object.entries(values.plots).map(([key, value]) => {
                                    const isPaid = typeof value === 'string' && value.toUpperCase().includes('PAGA');
                                    const amount = isPaid ? parseFloat(value.split(' - ')[0]) : value;
                                    return (
                                      <TableRow hover key={key}>
                                        <TableCell>{key}ª Parcela</TableCell>
                                        <TableCell align="right">
                                          {formattedCurrency(amount)}
                                          {isPaid && (
                                            <Chip
                                              label="Paga"
                                              size="small"
                                              style={{
                                                marginLeft: 8,
                                                backgroundColor: '#4caf50',
                                                color: 'white',
                                                height: 20,
                                                fontSize: '0.7rem',
                                              }}
                                            />
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                {(!values.plots || Object.keys(values.plots).length === 0) && (
                                  <TableRow>
                                    <TableCell colSpan={2} align="center">Venda à vista ou sem parcelas</TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>

                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Grid item>
                        {/* Novo Botão de Promissória */}
                        <Button
                          onClick={handlePrintPromissory}
                          color="primary"
                          startIcon={<DescriptionIcon />}
                          disabled={!modalValues.customer || modalValues.customer === 'Avulso'} // Desabilita se não tiver cliente
                          title={(!modalValues.customer || modalValues.customer === 'Avulso') ? "Necessário um cliente vinculado" : "Imprimir Promissória"}
                        >
                          Promissória
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={() => handleOpenPrintSale(modalValues)}
                          color="primary"
                          autoFocus
                          startIcon={<PrintIcon />}
                        >
                          Imprimir
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={
                            isEqualObject(values, modalValues)
                              ? () => handleModalView()
                              : () => submitForm()
                          }
                          variant={isEqualObject(values, modalValues) ? "text" : "contained"}
                          color={
                            isEqualObject(values, modalValues)
                              ? 'default'
                              : 'primary'
                          }
                        >
                          {isEqualObject(values, modalValues)
                            ? 'Fechar'
                            : 'Salvar Alterações'}
                        </Button>
                      </Grid>
                    </DialogActions>
                  </Form>
                )}
              </Formik>
            </Dialog>
            <Dialog
              fullWidth
              maxWidth="sm"
              open={modalPay}
              onExit={() => {
                setPayInfo();
                setPayment(initialPayment);
              }}
              onClose={() => setModalPay(false)}
            >
              <UIDialogTitle
                onClose={() => setModalPay(false)}
                id="alert-dialog-title"
              >
                Receber compra de {formatClient(modalValues.customer, clientInfo)}
              </UIDialogTitle>
              <DialogContent>
                <Grid container direction="row" spacing={1}>
                  {payInfo.data ? (
                    <TableContainer>
                      <Typography align="center" variant="h6" component="div">
                        Resumo do pagamento
                      </Typography>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell>Cliente</TableCell>
                            <TableCell>
                              {formatClient(modalValues.customer, clientInfo)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Vendedor</TableCell>
                            <TableCell>{credencials.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Valor pago</TableCell>
                            <TableCell>
                              {formattedCurrency(payment.amountPaid)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Valor restante</TableCell>
                            <TableCell>
                              {formattedCurrency(payInfo.data.valueRemaining)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            {payInfo.data.remnant !== 0 && (
                              <Typography
                                variant="h6"
                                component="div"
                                color="textSecondary"
                                style={{ marginTop: '10px' }}
                              >
                                TROCO: {formattedCurrency(payInfo.data.remnant)}
                              </Typography>
                            )}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Resumo da Venda
                        </Typography>
                        <Grid
                          container
                          spacing={2}
                          style={{ marginBottom: '10px' }}
                        >
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Total
                            </Typography>
                            <Typography variant="body1">
                              {formattedCurrency(modalValues.value)}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Já Pago
                            </Typography>
                            <Typography variant="body1">
                              {formattedCurrency(modalValues.amountPaid)}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Paper
                              elevation={0}
                              style={{
                                backgroundColor: '#f5f5f5',
                                padding: '10px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <div>
                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                >
                                  Restante a Receber
                                </Typography>
                                <Typography variant="h6" color="error">
                                  {formattedCurrency(
                                    parseFloat(modalValues.value) -
                                    parseFloat(modalValues.amountPaid),
                                  )}
                                </Typography>
                              </div>
                              <Box display="flex" gap={1}>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  startIcon={<MonetizationOnIcon />}
                                  onClick={handlePayNextInstallment}
                                >
                                  Receber Próxima Parcela
                                </Button>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  startIcon={<MonetizationOnIcon />}
                                  onClick={() =>
                                    changeValuesPayment(
                                      parseFloat(modalValues.value) -
                                      parseFloat(modalValues.amountPaid),
                                      'amountPaid',
                                    )
                                  }
                                >
                                  Receber Tudo
                                </Button>
                              </Box>
                            </Paper>
                          </Grid>
                        </Grid>
                        <Divider style={{ marginBottom: '20px' }} />
                      </Grid>

                      <Grid item xs={12}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="sale-search__paymentMethod">
                            Método de Pagamento
                          </InputLabel>
                          <Select
                            label="Método de Pagamento"
                            value={payment.paymentMethod}
                            onChange={(ev) =>
                              changeValuesPayment(
                                ev.target.value,
                                'paymentMethod',
                              )
                            }
                            labelId="sale-search__paymentMethod"
                            startAdornment={
                              <InputAdornment position="start">
                                <PaymentIcon color="action" />
                              </InputAdornment>
                            }
                          >
                            {paymentInfo.data &&
                              paymentInfo.data.map((pay) => (
                                <MenuItem key={pay.id} value={pay.id}>
                                  {pay.name}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          value={payment.plots}
                          error={Boolean(payment.errors)}
                          helperText={payment.errors}
                          label="Parcelas"
                          type="number"
                          variant="outlined"
                          size="small"
                          onChange={(ev) =>
                            changeValuesPayment(ev.target.value, 'plots')
                          }
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CurrencyTextField
                          type="tel"
                          value={payment.amountPaid}
                          error={Boolean(payment.errors)}
                          helperText={payment.errors}
                          label="Valor a Pagar"
                          variant="outlined"
                          size="small"
                          decimalCharacter=","
                          digitGroupSeparator="."
                          currencySymbol="R$"
                          outputFormat="string"
                          onChange={(ev, value) =>
                            changeValuesPayment(value, 'amountPaid')
                          }
                          fullWidth
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                {payInfo.data ? (
                  <Button
                    onClick={() => setModalPay(false)}
                    color="primary"
                    autoFocus
                  >
                    Sair
                  </Button>
                ) : (
                  <>
                    <Button onClick={() => setModalPay(false)} color="primary">
                      Cancelar
                    </Button>
                    <Button
                      onClick={onPay}
                      color="primary"
                      autoFocus
                      disabled={Number(payment.amountPaid) <= 0}
                    >
                      Receber
                    </Button>
                  </>
                )}
              </DialogActions>
              <UIDialogConfirm
                open={alert}
                close={() => setAlert(false)}
                data={payInfo}
                messageSucess={`Venda paga com sucesso pelo ${formatClient(modalValues.customer, clientInfo) || 'Cliente'
                  }`}
                messageError="Ops, ocorreu um erro ao manipular a categoria"
              />
            </Dialog>
            <Dialog
              fullWidth
              open={modalTerminates}
              onExit={() => {
                setTerminatesInfo();
                setTextConfirm(initialTextConfirm);
              }}
              onClose={() => setModalTerminates(false)}
            >
              <UIDialogTitle
                onClose={() => setModalTerminates(false)}
                id="alert-dialog-title"
              >
                Atenção: valor total de pagamento ainda não foi atingido
              </UIDialogTitle>
              <DialogContent>
                <Grid container direction="row" spacing={1}>
                  {terminatesInfo.data ? (
                    <TableContainer>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell>Valor da conta</TableCell>
                            <TableCell>
                              {formattedCurrency(terminatesInfo.data.sale.value)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Valor pago</TableCell>
                            <TableCell>
                              {formattedCurrency(
                                terminatesInfo.data.sale.amountPaid,
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <>
                      <Typography paragraph>
                        Fechando esta venda agora, não será possível informar mais
                        pagamentos da mesma. Se tiver certeza, digite{' '}
                        <strong>{initialTextConfirm.requiredPrompt}</strong> no
                        campo abaixo:
                      </Typography>
                      <TextField
                        value={confirmationPrompt.confirmationPrompt}
                        label="Digite o texto"
                        placeholder={initialTextConfirm.requiredPrompt}
                        helperText={confirmationPrompt.error}
                        error={!!confirmationPrompt.error}
                        onChange={(ev) =>
                          setTextConfirm({ confirmationPrompt: ev.target.value })
                        }
                        fullWidth
                      />
                    </>
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                {terminatesInfo.data ? (
                  <Button
                    onClick={() => setModalTerminates(false)}
                    color="primary"
                    autoFocus
                  >
                    Sair
                  </Button>
                ) : (
                  <>
                    <Button
                      onClick={() => setModalTerminates(false)}
                      color="primary"
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={onCloseSale}
                      disabled={!confirmationPrompt.allow}
                      color="secondary"
                      autoFocus
                    >
                      Ok, fechar
                    </Button>
                  </>
                )}
              </DialogActions>
            </Dialog>
            <UIDialogConfirm
              open={alert}
              close={() => setAlert(false)}
              data={updateInfo}
              setrequestinfo={() => onSearch(search)}
              messageSucess={
                updateInfo.data
                  ? updateInfo.data.message
                  : 'Produto atualizado com sucesso'
              }
              type="success"
            />
            <UIDialogConfirm
              open={alertTerminates}
              close={() => setAlertTerminates(false)}
              data={terminatesInfo}
              messageSucess={terminatesInfo.data && terminatesInfo.data.message}
              messageError={
                (terminatesInfo.data && terminatesInfo.data.message) ||
                'Ops, ocorreu um erro ao fechar a venda'
              }
            />
          </>
        )}

        <Dialog
          fullWidth
          open={modalBatchPay}
          onClose={() => setModalBatchPay(false)}
          onExited={() => setBatchPayment({ paymentMethod: 6 })}
        >
          <UIDialogTitle
            onClose={() => setModalBatchPay(false)}
            id="batch-pay-dialog-title"
          >
            Receber {selectedSales.length} Venda(s) em Lote
          </UIDialogTitle>
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">
                  Valor Total Pendente: {formattedCurrency(totalPendingBatch)}
                </Typography>
                <Typography variant="body2">
                  Isto pagará o valor total restante de todas as{' '}
                  {selectedSales.length} vendas selecionadas.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel shrink id="sale-search__batchPaymentMethod">
                    Metódo de pagamento
                  </InputLabel>
                  <Select
                    value={batchPayment.paymentMethod}
                    onChange={(ev) =>
                      setBatchPayment({ paymentMethod: ev.target.value })
                    }
                    labelId="sale-search__batchPaymentMethod"
                    displayEmpty
                  >
                    {paymentInfo.data &&
                      paymentInfo.data.map((pay) => (
                        <MenuItem key={pay.id} value={pay.id}>
                          {pay.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setModalBatchPay(false)} color="primary">
              Cancelar
            </Button>
            <Button onClick={onBatchPay} color="primary" autoFocus>
              Confirmar Recebimento
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal para Recibo em Lote */}
        <Dialog
          fullWidth
          open={showBatchReceipt}
          onClose={() => setShowBatchReceipt(false)}
        >
          <UIDialogTitle
            onClose={() => setShowBatchReceipt(false)}
            id="batch-receipt-dialog-title"
          >
            Recibos de Pagamento em Lote
          </UIDialogTitle>
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              {batchReceipts &&
                batchReceipts.map((receipt) => (
                  <Grid item xs={12} key={receipt.id}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel-${receipt.id}-content`}
                        id={`panel-${receipt.id}-header`}
                      >
                        <Grid
                          container
                          justify="space-between"
                          alignItems="center"
                        >
                          <Typography>
                            #{receipt.id} -{' '}
                            {formatClient(receipt.customer || 'Avulso')}
                          </Typography>
                          <Typography>
                            {formattedCurrency(receipt.paidNow)}
                          </Typography>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container direction="column">
                          <Typography variant="body2">
                            Pagamento via: {receipt.paymentMethodName}
                          </Typography>
                          <Typography variant="body2">
                            Data: {format(new Date(), 'dd/MM/yyyy HH:mm')}
                          </Typography>
                          <Box mt={2}>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<PrintIcon />}
                              onClick={() => printSingleReceipt(receipt)}
                            >
                              Imprimir Recibo
                            </Button>
                          </Box>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowBatchReceipt(false)} color="primary">
              Fechar
            </Button>
            <Button
              onClick={printBatchReceipts}
              color="primary"
              variant="contained"
              autoFocus
              startIcon={<PrintIcon />}
            >
              Imprimir Todos
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal para Recibo Individual */}
        <Dialog
          open={showSingleReceipt}
          onClose={() => setShowSingleReceipt(false)}
          maxWidth="xs"
          fullWidth
        >
          <UIDialogTitle
            onClose={() => setShowSingleReceipt(false)}
            id="single-receipt-dialog-title"
          >
            Pagamento Realizado
          </UIDialogTitle>
          <DialogContent>
            <Box textAlign="center" py={3}>
              <CheckCircleIcon
                style={{ fontSize: 60, color: '#4caf50', marginBottom: 16 }}
              />
              <Typography variant="h6" style={{ marginBottom: 8 }}>
                Venda #{singleReceiptData?.id} paga com sucesso!
              </Typography>
              <Typography variant="body1" color="textSecondary">
                Valor Pago: {formattedCurrency(singleReceiptData?.paidNow)}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowSingleReceipt(false)} color="primary">
              Fechar
            </Button>
            <Button
              onClick={() => printSingleReceipt(singleReceiptData)}
              color="primary"
              variant="contained"
              autoFocus
              startIcon={<PrintIcon />}
            >
              Imprimir Recibo
            </Button>
          </DialogActions>
        </Dialog>

        <UIDialogConfirm
          open={alertBatch}
          close={() => setAlertBatch(false)}
          data={{}}
          messageSucess={`Pagamento em lote processado.`}
          type="success"
        />

        <PrintPreviewModal
          open={modalPrint}
          handleClose={() => setModalPrint(false)}
          saleData={printSaleData || modalValues}
          credencials={credencials}
        />
        
        <Backdrop style={{ zIndex: 99999, color: '#fff' }} open={loadingDetails}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default SaleSearch;